// turning ai2html's output into a module allows
// webpack to apply hot module replacement.
// we obviously want to bake it into the html in production
// that's why we're conditionally requiring it
import { Child } from 'pym.js';
// import ai2html from './ai2html-graphic.html';
import desktopImage1 from '!!url-loader?limit=100000!./img/ai2html-graphic-desktop-dt-1.png';
import desktopImage2 from '!!url-loader?limit=100000!./img/ai2html-graphic-desktop-dt-2.png';
import desktopImage3 from '!!url-loader?limit=100000!./img/ai2html-graphic-desktop-dt-3.png';
import desktopImage4 from '!!url-loader?limit=100000!./img/ai2html-graphic-desktop-dt-4.png';
import mobile320Image1 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-1.png';
import mobile320Image2 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-2.png';
import mobile320Image3 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-3.png';
import mobile320Image4 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-4.png';
import mobile320Image5 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-5.png';
import mobile320Image6 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-6.png';
import mobile320Image7 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-7.png';
import mobile320Image8 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile320-mobile-8.png';
import mobile375Image1 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-1.png';
import mobile375Image2 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-2.png';
import mobile375Image3 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-3.png';
import mobile375Image4 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-4.png';
import mobile375Image5 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-5.png';
import mobile375Image6 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-6.png';
import mobile375Image7 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-7.png';
import mobile375Image8 from '!!url-loader?limit=100000!./img/ai2html-graphic-mobile375-mobile-8.png';
import Zion from './utils/Zion';
import meta from './data/meta.json';


// styles
import './styles/index.scss';
import './styles/graphic.scss';

console.log('index.js is loaded');

const pkg = require('../package.json');

let ai2html = null;
const artboardImages = {
  'g-ai2html-graphic-desktop': [
    desktopImage1, desktopImage2, desktopImage3, desktopImage4,
  ],
  'g-ai2html-graphic-mobile320': [
    mobile320Image1, mobile320Image2, mobile320Image3, mobile320Image4,
    mobile320Image5, mobile320Image6, mobile320Image7, mobile320Image8,
  ],
  'g-ai2html-graphic-mobile375': [
    mobile375Image1, mobile375Image2, mobile375Image3, mobile375Image4,
    mobile375Image5, mobile375Image6, mobile375Image7, mobile375Image8,
  ],
};

if (process.env.NODE_ENV === 'development') {
  // turning ai2html's output into a module allows
  // webpack to apply hot module replacement.
  // we obviously want to bake it into the html in production
  // that's why we're conditionally requiring it
  ai2html = require('./ai2html-graphic.html');
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

// console.clear();

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        const value = id === 'source' ? meta[id].replace(/^source:\s*/i, '') : meta[id];
        node.innerHTML = id === 'source' ? `Source: ${value}` : value;
      }
    });

    const source = document.querySelector('.source');
    const sourceValue = (meta.source || '').replace(/^source:\s*/i, '') || meta.credit || '';
    if (source) source.innerHTML = `Source: ${sourceValue}`;
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // console.log('pymChild:', pymChild);

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw() {
  if (process.env.NODE_ENV === 'development') {
    // the code below applies the ai2html during development mode.
    const figure = document.querySelector('#ai2html-graphic');
    figure.innerHTML = ai2html;
    // If you want to write code for this graphic,
    // move this stuff outside the if block that it's in.
  }

  Object.keys(artboardImages).forEach((artboardId) => {
    const artboard = document.getElementById(artboardId);
    if (!artboard) return;

    artboard.querySelectorAll('svg image').forEach((image, i) => {
      const imageUrl = artboardImages[artboardId][i];
      if (!imageUrl) return;

      const previous = image.previousElementSibling;
      if (!previous || !previous.hasAttribute('data-image-backdrop')) {
        const backdrop = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        ['x', 'y', 'width', 'height', 'transform'].forEach((attribute) => {
          if (image.hasAttribute(attribute)) {
            backdrop.setAttribute(attribute, image.getAttribute(attribute));
          }
        });
        backdrop.setAttribute('data-image-backdrop', '');
        backdrop.setAttribute('fill', '#fff');
        image.parentNode.insertBefore(backdrop, image);
      }

      image.setAttribute('href', imageUrl);
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imageUrl);
    });
  });
}

window.pymChild.onMessage('viewport-iframe-position', (parentInfo) => {
  const positions = parentInfo.split(' ').map(pos => parseFloat(pos));

  const trk = document.querySelectorAll('[data-name="rectangle"], [data-name="zoom"], [data-name="arrow"]');
  trk.forEach((trkOb) => {
    // Only hide objects after position tracking is confirmed to be working.
    trkOb.classList.add('fade');

    if (trkOb.matches('[data-name="arrow"]')) {
      const rect = trkOb.getBoundingClientRect();
      const screenTop = rect.top + positions[2];
      const screenBottom = rect.bottom + positions[2];
      trkOb.classList.toggle('inview', screenTop < positions[1] && screenBottom > 0);
      return;
    }

    const tp = trkOb.getBoundingClientRect().top;
    if (tp > 0) {
      const tpos = 1 - ((tp + positions[2]) / positions[1]);

      trkOb.classList.toggle('inview', tpos > 0.2);
    }
  });
});

window.addEventListener('scroll', () => {
  window.pymChild.getParentPositionInfo(); // Request updated position
  console.log('Scroll event fired in iframe, requesting position update...');
});

setInterval(() => {
  window.pymChild.getParentPositionInfo();
}, 200);

// function rAf() {
//   window.pymChild.getParentPositionInfo();
//   requestAnimationFrame(rAf);
// }
// rAf();
